import React from 'react';

export const BookmarkPrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.66602 3.3335C2.66602 2.80306 2.87673 2.29436 3.2518 1.91928C3.62687 1.54421 4.13558 1.3335 4.66602 1.3335H11.3327C11.8631 1.3335 12.3718 1.54421 12.7469 1.91928C13.122 2.29436 13.3327 2.80306 13.3327 3.3335V14.0188C13.3327 14.8322 12.4127 15.3055 11.7513 14.8328L7.99935 12.1528L4.24735 14.8328C3.58535 15.3062 2.66602 14.8328 2.66602 14.0195V3.3335Z"
        fill="#774EFF"
      />
    </svg>
  );
};
